import {
  FileText,
  Calendar,
  User,
  Home,
  MessageSquare,
  Car,
  Code,
} from "lucide-react";

// --- Field Configuration for Extraction Display ---
export const FIELD_CONFIG = {
  "NOS REFERENCES": { label: "Nos Références", icon: FileText, backendField: "nos_references" },
  "DATE DE MISSION": { label: "Date de Mission", icon: Calendar, backendField: "date_mission" },
  "MANDANT": { label: "Mandant", icon: User, backendField: "mandant" },
  "AGENCE": { label: "Agence", icon: Home, backendField: "agence" },
  "DATE ACCIDENT": { label: "Date Accident", icon: Calendar, backendField: "date_accident" },
  "ASSURE": { label: "Assuré(e)", icon: User, backendField: "assure" },
  "TELEPHONE ASSURE": { label: "Téléphone Assuré", icon: MessageSquare, backendField: "telephone_assure" },
  "IMMATRICULATION": { label: "Immatriculation", icon: Car, backendField: "immatriculation" },
  "EXPERTISE TYPE": { label: "Type d'Expertise", icon: Code, backendField: "expertise_type" },
  "ADRESSE EXPERTISE": { label: "Adresse Expertise", icon: Home, backendField: "adresse_expertise" },
};

// --- Available Models ---
export const AVAILABLE_MODELS = [
  {
    value: "gemini-3-flash-preview",
    label: "Gemma 3 12B",
    provider: "gemini"
  },
  {
    value: "mistralai/mistral-small-3.1-24b-instruct:free", // Backend default
    label: "Qwen 2.5 VL 72B",
    provider: "qwen"
  }
];

// Helper to get readable label
export const getFieldLabel = (key) => {
  const config = Object.values(FIELD_CONFIG).find(
    (field) => field.backendField === key.toLowerCase().replace(/ /g, '_')
  );
  return config ? config.label : key.replace(/_/g, ' ');
};
